import Vue from "vue";
import Vuex from "vuex";

import ToastStore from "@Scripts/Stores/ToastStore";

import myMectronicArticleStore from "@Scripts/Stores/MyMectronicArticleStore";
import MyMectronicTrainingStore from "@Scripts/Stores/MyMectronicTrainingStore";
import MyMectronicMarketingStore from "@Scripts/Stores/MyMectronicMarketingStore";
import CartStore from "@Scripts/Stores/CartStore";

Vue.use(Vuex);

export const store = new Vuex.Store({});

store.registerModule("app-toastStore", ToastStore);
store.registerModule("myMectronicArticleStore", myMectronicArticleStore);
store.registerModule("myMectronicTrainingStore", MyMectronicTrainingStore);
store.registerModule("myMectronicMarketingStore", MyMectronicMarketingStore);
store.registerModule("cartStore", CartStore);